import { render } from "./recommend.vue?vue&type=template&id=3b995b16&ts=true"
import script from "./recommend.vue?vue&type=script&lang=ts"
export * from "./recommend.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__